import React, { useState, useEffect } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../../redux/actions/index";
import { useForm } from "react-hook-form";
import { Button } from "@chakra-ui/react";
import { PERMISSION_LEVEL } from "../../../config/constant/PermissionLevel";
import _ from "lodash";
import SpinnerLoading from "components/Loading/SpinnerLoading";
export default function EditPosition() {
  const { register, handleSubmit, errors } = useForm();
  const { id, pid } = useParams();
  const history = useHistory();
  const department = useSelector((state) => state.department);
  const position = useSelector((state) => state.position);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    dispatch(actions.departmentAll()).then(() => {
      dispatch(actions.positionGet(pid)).then(() => {
        setIsLoading(true);
      });
    });
    return () => {};
  }, []);
  const genDepartmentOption = () =>
    _.map(department, (_department) => {
      if (_department.department_id == id) {
        return (
          <option
            key={_department.department_id}
            selected
            value={_department.department_id}
          >
            {_department.department_name}
          </option>
        );
      } else {
        return (
          <option
            key={_department.department_id}
            value={_department.department_id}
          >
            {_department.department_name}
          </option>
        );
      }
    });
  const genPermissionLevel = () => {
    return _.map(PERMISSION_LEVEL, (level, index) => {
      if (level == position.permission_level)
        return (
          <option key={index} value={level} selected>
            {level}{" "}
          </option>
        );
      else
        return (
          <option key={index} value={level}>
            {level}{" "}
          </option>
        );
    });
  };
  const onSubmit = (data, e) => {
    // console.log(data);
    data.position_id = position.position_id;
    dispatch(actions.positionPut(data)).then(() => {
      console.log("แก้ไขตำแหน่งสำเร็จ");
      history.push("/hrms/department/details/" + id);
    });
  };
  return isLoading ? (
    <div>
      <h2 className="text-gray-800 text-xl font-semibold py-1">แก้ไขตำแหน่ง</h2>
      <div className="flex justify-between py-6">
        <Link to={"/hrms/department/details/" + id}>
          <Button variant="outline">กลับ</Button>
        </Link>
      </div>
      <div className="p-4">
        <div className="flex content-center items-center justify-center h-full">
          <div className="w-full lg:w-6/12 px-4">
            {" "}
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="relative w-full mb-3">
                <label
                  className="block uppercase text-gray-700 text-xs font-bold mb-2"
                  htmlFor="grid-password"
                >
                  ชื่อตำแหน่ง <label className="text-red-600 text-xs"> *</label>
                </label>
                <input
                  name="position_name"
                  type="text"
                  required
                  ref={register}
                  defaultValue={position.position_name}
                  className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                  placeholder="ชื่อตำแหน่ง"
                />
              </div>

              <div className="relative w-full mb-3">
                <label
                  className="block uppercase text-gray-700 text-xs font-bold mb-2"
                  htmlFor="grid-password"
                >
                  แผนก <label className="text-red-600 text-xs"> *</label>
                </label>
                <select
                  name="department_id"
                  required
                  ref={register}
                  className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                >
                  {genDepartmentOption()}
                </select>
              </div>

              <div className="relative w-full mb-3">
                <label
                  className="block uppercase text-gray-700 text-xs font-bold mb-2"
                  htmlFor="grid-password"
                >
                  รายละเอียด <label className="text-red-600 text-xs"> *</label>
                </label>
                <textarea
                  name="position_salary"
                  type="text"
                  required
                  ref={register}
                  defaultValue={position.position_salary}
                  className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                  placeholder="รายละเอียด"
                />
              </div>
              <div className="relative w-full mb-3">
                <label
                  className="block uppercase text-gray-700 text-xs font-bold mb-2"
                  htmlFor="grid-password"
                >
                  จัดการสิทธิการเข้าถึง <label className="text-red-600 text-xs"> *</label>
                </label>
                <select
                  name="permission_level"
                  required
                  ref={register}
                  className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                >
                  {genPermissionLevel()}
                </select>
              </div>
              <div className="text-center mt-6">
                <Button isFullWidth colorScheme="blue" type="submit">
                  บันทึก
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <SpinnerLoading />
  );
}
